(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-with-info"]) return;
  try {
    
  function validateEmail(email) {
	    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(email);
	  }
	  
  function validate() {
  if($("#ContactFormEmail").val()){
    var $result = $("#result");
    var email = $("#ContactFormEmail").val();
    $result.text(""); 

    if (!validateEmail(email)) {
      $result.text("Email is not valid");
      $result.css({"color":"red", "display": "block" });
      return false;
    }
  }

  }
  $(document).ready(function () {
    $("#shopify-section-contact-form-with-info #contact_form button").bind("click", validate);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-tech"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-hv2-play]').forEach(function (btn) {
    if (btn.dataset.hv2Bound) return;
    btn.dataset.hv2Bound = '1';
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-hv2-tech-media]');
      if (!wrap) return;
      /* Pin the current box height before swapping content — the injected
         video is absolutely positioned, so the box must keep its size */
      var h = wrap.offsetHeight;
      if (h) wrap.style.height = h + 'px';
      var poster = btn.dataset.hv2Poster ? ' poster="' + btn.dataset.hv2Poster + '"' : '';
      wrap.innerHTML = '<video src="' + btn.dataset.hv2Src + '" controls autoplay playsinline' + poster + '></video>';
      var v = wrap.querySelector('video');
      if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-band-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pb-section').forEach(function (root) {
    if (root.dataset.pbInit) return;
    root.dataset.pbInit = '1';

    // ---- gallery (image + video; hero is a swipeable slider on mobile) ----
    var hero = root.querySelector('[data-pb-hero]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.pb-thumbs [data-pb-media]'));
    var current = 0;

    function setActive(btn) {
      root.querySelectorAll('.pb-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      if (btn && btn.classList.contains('pb-thumb')) {
        btn.classList.add('is-active');
        if (btn.scrollIntoView) btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }

    function playVideoInto(el, src, poster) {
      el.innerHTML = '<video src="' + src + '" controls autoplay playsinline' + (poster ? ' poster="' + poster + '"' : '') + '></video>';
      var v = el.querySelector('video');
      if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }

    function renderMedia(btn, autoplay) {
      if (!hero || !btn) return;
      if (btn.dataset.pbMedia === 'video') {
        var poster = btn.dataset.pbPoster ? ' poster="' + btn.dataset.pbPoster + '"' : '';
        hero.innerHTML = '<video src="' + btn.dataset.pbSrc + '" controls playsinline preload="metadata"' + (autoplay ? ' autoplay' : '') + poster + '></video>';
        if (autoplay) { var v = hero.querySelector('video'); if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
      } else {
        hero.innerHTML = '<img class="pb-hero-img" src="' + btn.dataset.pbSrc + '" alt="">';
      }
      setActive(btn);
      var i = thumbs.indexOf(btn);
      if (i > -1) current = i;
    }

    root.querySelectorAll('[data-pb-media]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isVideo = btn.dataset.pbMedia === 'video';
        var inGrid = btn.classList.contains('pb-grid-cell');

        // Video in the desktop grid: play in place (don't touch the hero).
        if (isVideo && inGrid) {
          var wrap = document.createElement('div');
          wrap.className = 'pb-grid-cell pb-cell-video pb-cell-playing';
          playVideoInto(wrap, btn.dataset.pbSrc, btn.dataset.pbPoster);
          btn.replaceWith(wrap);
          return;
        }

        // Image in the desktop grid: do nothing (all images are already shown; don't swap the hero).
        if (!isVideo && inGrid) return;

        renderMedia(btn, isVideo);
      });
    });

    // swipe left/right on the hero (mobile) to move between slides
    if (hero && thumbs.length > 1) {
      var touchX = 0, touchY = 0;
      hero.addEventListener('touchstart', function (e) {
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchX;
        var dy = e.changedTouches[0].clientY - touchY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        current = (current + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
        renderMedia(thumbs[current], false);
      }, { passive: true });
    }

    // ---- size chart link -> popup modal (fallback: scroll to accordion) ----
    var scLink = root.querySelector('[data-pb-sizechart]');
    var scModal = root.querySelector('[data-pb-sizechart-modal]');
    var scAcc = root.querySelector('[data-pb-sizechart-acc]');
    if (scLink && scModal) {
      function closeModal() {
        scModal.hidden = true;
        document.documentElement.style.overflow = '';
      }
      scLink.addEventListener('click', function (e) {
        e.preventDefault();
        scModal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      });
      scModal.querySelectorAll('[data-pb-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !scModal.hidden) closeModal();
      });
    } else if (scLink && scAcc) {
      scLink.addEventListener('click', function (e) {
        e.preventDefault();
        scAcc.open = true;
        scAcc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // ---- quantity stepper ----
    var qtyInput = root.querySelector('[data-pb-qty-input]');
    root.querySelectorAll('[data-pb-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        v = btn.dataset.pbQty === 'plus' ? v + 1 : Math.max(1, v - 1);
        qtyInput.value = v;
      });
    });

    // ---- variants ----
    var json = root.querySelector('[data-pb-product-json]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = root.querySelector('[data-pb-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-pb-add]');
    var addText = root.querySelector('[data-pb-add-text]');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('.pb-optgroup').forEach(function (group, i) {
        var checked = group.querySelector('input:checked');
        opts[i] = checked ? checked.value : null;
      });
      return opts;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      });
    }

    function showVariantImage(v) {
      // When the selected variant has its own image, bring it to the hero (desktop = top,
      // mobile = the strip slides to it). No-op for variants without a dedicated image.
      if (!v || !v.featured_image) return;
      var fi = v.featured_image;
      var match = null;
      if (fi.id) {
        match = thumbs.filter(function (b) {
          return b.dataset.pbImageId && String(b.dataset.pbImageId) === String(fi.id);
        })[0];
      }
      if (match) {
        renderMedia(match, false);
      } else if (fi.src && hero) {
        hero.innerHTML = '<img class="pb-hero-img" src="' + fi.src + '" alt="">';
        setActive(null);
        current = -1;
      }
    }

    function update() {
      var opts = selectedOptions();
      if (!opts.length) return;
      var v = matchVariant(opts);
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (v.available) {
        addBtn.disabled = false;
        addText.textContent = 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addText.textContent = 'Sold Out';
      }
      showVariantImage(v);
    }

    root.querySelectorAll('.pb-optgroup input').forEach(function (input) {
      input.addEventListener('change', update);
    });

    // show the initially-selected variant's image (if it has one) on load
    showVariantImage(matchVariant(selectedOptions()));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pv-play]').forEach(function (btn) {
    if (btn.dataset.pvBound) return;
    btn.dataset.pvBound = '1';
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-pv-media]');
      if (!wrap) return;
      var poster = btn.dataset.pvPoster ? ' poster="' + btn.dataset.pvPoster + '"' : '';
      wrap.innerHTML = '<video class="pv-video" src="' + btn.dataset.pvSrc + '" controls autoplay playsinline' + poster + '></video>';
      var v = wrap.querySelector('video');
      if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-image-animated-banner"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
   $(".text_image_banner_inner:first-child img.zoomIn").addClass("animatein");
});
$(window).scroll(function () {
  $(".text_image_banner_inner img.zoomIn").each(function(){
    if (isInViewportsdata($(this))){
		$(this).addClass("animatein");
    }
  }); 
  $(".text_image_banner_inner img.zoomOut").each(function(){
    if (isInViewportsdata($(this))){
		$(this).addClass("animateout");
    }
  }); 

});
function isInViewportsdata(elem){
   return $(elem).offset().top - $(window).scrollTop() < $(elem).height() ;
}

  } catch(e) { console.error(e); }
})();
})();
